import { render, staticRenderFns } from "./PIArchive.vue?vue&type=template&id=24186033&scoped=true"
import script from "./PIArchive.vue?vue&type=script&lang=js"
export * from "./PIArchive.vue?vue&type=script&lang=js"
import style0 from "./PIArchive.vue?vue&type=style&index=0&id=24186033&prod&lang=css"
import style1 from "./PIArchive.vue?vue&type=style&index=1&id=24186033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24186033",
  null
  
)

export default component.exports